import React, {useLayoutEffect, useState,} from "react";
import "bootstrap/dist/css/bootstrap.css";
import './App.scss';
import Table from "./components/MaterialTable/Table";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import ConfigToolTheme from "./components/ConfigToolTheme";
import {HashRouter, Route, Routes} from "react-router-dom";
import BasicTabs from "./components/TabPanel";
import {ProjectProvider} from "./context/project-context";
import keycloak from "./api/Keycloak";
import {ReactKeycloakProvider} from '@react-keycloak/web'
import {Box, ThemeProvider} from "@mui/material";


const App = () => {
    const [, setWindowWidth] = useState(0);
    const [, setWindowHeight] = useState(0);
    const [, setIsAuthenticated] = useState(false);

    let resizeWindow = () => {
        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
    };

    useLayoutEffect(() => {
        window.addEventListener("resize", resizeWindow);
        resizeWindow();
        return () => window.removeEventListener("resize", resizeWindow);
        //eslint-disable-next-line
    }, [keycloak]);

    const handleOnEvent = async (event, error) => {
        if (event === 'onAuthSuccess') {
            if (keycloak.authenticated) {
                setIsAuthenticated(true);
            }
        }
    }

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={
                {
                    onLoad: 'login-required',
                    checkLoginIframe: false
                }
            }
            onEvent={(event, error) => handleOnEvent(event, error)}>
            {keycloak.token ?
                <ProjectProvider>
                    <Box
                        sx={{
                            textAlign: 'center',
                            minHeight: '100%',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <ThemeProvider theme={ConfigToolTheme}>
                            <HashRouter>
                                <Header/>
                                <Routes>
                                    <Route exact path="/" element={<Table/>}/>
                                    <Route exact path="tabs" element={<BasicTabs/>}/>
                                </Routes>
                                <Footer/>
                            </HashRouter>
                        </ThemeProvider>
                    </Box>
                </ProjectProvider>
                : null}
        </ReactKeycloakProvider>
    );
}

export default App;